import { render, staticRenderFns } from "./NewEditCalendarioLetivoPage.vue?vue&type=template&id=6fc8b3a4&scoped=true"
import script from "./NewEditCalendarioLetivoPage.vue?vue&type=script&lang=js"
export * from "./NewEditCalendarioLetivoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditCalendarioLetivoPage.vue?vue&type=style&index=0&id=6fc8b3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8b3a4",
  null
  
)

export default component.exports